'use client';

import flush from 'just-flush';
import { logoCarouselSection } from '@stereoagency/sanity-schema';
import { LogoCarouselSection as UILogoCarouselSection } from '@stereoagency/ui';
import { linkAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof logoCarouselSection.schema.logoCarouselSection;

export default function LogoCarouselSection({ title, logos }: Props) {
  if (!logos?.length) {
    return null;
  }

  return (
    <UILogoCarouselSection
      title={title}
      cards={flush(
        logos.map((logo) => {
          if (!logo.logo?.asset._ref) {
            return null;
          }

          return {
            logo: sanityImageAsProps(logo.logo),
            action: logo.link ? linkAsProps(logo.link) : undefined
          };
        })
      )}
    />
  );
}
